module.exports = __webpack_public_path__ + "img/slide-text_inactive.4ea135bb.svg";